import { TrendingUp } from "lucide-react";

// Brand lockup: honours a custom uploaded logo (general.logo_url). When none is
// set (still the default "/logo.png"), it renders the Fx Cloud icon + wordmark.
export function BrandLogo({ logoUrl, siteName = "Fx Cloud", textClass = "text-white", className = "", iconClass = "h-9 w-9", textSize = "text-xl" }) {
  const custom = logoUrl && logoUrl !== "/logo.png";
  if (custom) {
    return <img src={logoUrl} alt={siteName} className={`h-9 w-auto ${className}`} />;
  }
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <div className={`${iconClass} rounded-lg bg-brandblue grid place-items-center text-white shrink-0`}>
        <TrendingUp className="h-5 w-5" />
      </div>
      <span className={`font-display font-extrabold ${textSize} tracking-tight ${textClass}`}>{siteName}</span>
    </div>
  );
}
